import template from './ecocode-trustpilot-overview.html.twig';
import './ecocode-trustpilot-overview.scss';

const { Component } = Shopware;

Component.register('ecocode-trustpilot-overview', {
    template,
    inject: ['ecocodeTrustpilotApiService'],
    metaInfo() {
        return {
            title: this.$createTitle()
        };
    },

    async mounted() {
        const { status, businessUnits } = await this.ecocodeTrustpilotApiService.overview();
        this.status = status;

        if (status === 'not_connected' && this.$route.query.setupCancelled !== "1") {
            this.$router.push({ name: 'ecocode.trustpilot.setup.welcome' });
        }

        if (status === 'invalid_token') {
            this.$router.push({ name: 'ecocode.trustpilot.setup.connect' });
        }

        this.isLoading = false;
        this.businessUnits = businessUnits;
    },
    data() {
        return {
            isLoading: true,
            loading: true,
            status: null,
            businessUnits: null
        };
    }
});
